@if (promotion.details) {
    @if (promotion.details.backgroundImageUrl) {
        <div class="image">
            <img placeholder fill ngSrcset="1x, 2x, 3x" [ngSrc]="promotion.details.backgroundImageUrl" />
            @if (promotion.details.heroImageUrl) {
                <img placeholder fill ngSrcset="1x, 2x, 3x" [ngSrc]="promotion.details.heroImageUrl" />
            }
        </div>
    }
    <div class="description" [innerHTML]="promotion.details.description"></div>

    <ms-crm-promotion-status-button class="status-button" [promotion]="promotion" (buttonClick)="onButtonClick($event)" />

    <div class="bcms-toggle-tnc">
        <div class="bcms-toggle-tnc-caption dh" [ngClass]="{ 'tnc-visible': tncVisible }" (click)="toggleTnc()">
            <span [innerHTML]="translation.TermsAndConditions"></span>
            <vn-icon name="theme-down" size="8" class="toggle-tnc-icon" />
        </div>
        @if (tncVisible) {
            <div class="bcms-toggle-tnc-details pc-txt txt-xs" [innerHTML]="promotion.details.termsAndConditions"></div>
        }
    </div>
}
